import * as Sentry from '@sentry/react'

const isDev = process.env.NODE_ENV === 'development'

/**
 * Log an informational message to Sentry.
 * In development, also prints to the console.
 *
 * @param {string} message
 * @param {object} context - Extra metadata: { module, function, payload, ... }
 */
export const logInfo = (message, context = {}) => {
  Sentry.captureMessage(message, {
    level: 'info',
    extra: context,
  })
  if (isDev) {
    // eslint-disable-next-line no-console
    console.info('[INFO]', message, context)
  }
}

/**
 * Log a warning to Sentry.
 * In development, also prints to the console.
 *
 * @param {string} message
 * @param {object} context - Extra metadata: { module, function, payload, ... }
 */
export const logWarning = (message, context = {}) => {
  Sentry.captureMessage(message, {
    level: 'warning',
    extra: context,
  })
  if (isDev) {
    // eslint-disable-next-line no-console
    console.warn('[WARNING]', message, context)
  }
}

/**
 * Log an error to Sentry.
 * In development, also prints to the console.
 *
 * @param {Error|string} error
 * @param {object} context - Extra metadata: { module, function, payload, message, ... }
 */
export const logError = (error, context = {}) => {
  const err = error instanceof Error ? error : new Error(String(error))
  Sentry.captureException(err, { extra: context })
  if (isDev) {
    // eslint-disable-next-line no-console
    console.error('[ERROR]', error, context)
  }
}
